<template>
  <img width="24" src="@/assets/img/newIcon/loading-circle.gif" />
</template>
<script>
export default {
  name: "LoadingIcon",
}
</script>
